import * as z from "zod";

import { boardMeetingContentSchema } from "./board-meeting-content";
import { boardMeetingSectionSchema } from "./board-meeting-section";

export const boardMeetingSectionWithContentsSchema =
  boardMeetingSectionSchema.extend({
    contents: z.array(boardMeetingContentSchema).default([]),
  });

export type BoardMeetingSectionWithContents = z.infer<
  typeof boardMeetingSectionWithContentsSchema
>;
